import EFPicture from 'elem/compCommon/EFPicture';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper';
import { useGlobal } from '@/utils/useGlobal';

export default function E() {
    const { useEffect, useState, useLang, gtm, useRouter } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('solar_panel_220w_single');
    const [swiper, setSwiper] = useState(null);
    const [active, setActive] = useState(0);
    const arr = [
        {
            img: '5_1',
            title: t('E_1_title'),
            desc: t('E_1_desc'),
        },
        {
            img: '5_2',
            title: t('E_2_title'),
            desc: t('E_2_desc'),
        },
    ];

    const handleSlideChange = (n: number) => {
        swiper.slideTo(n);
        setActive(n);
    };

    return (
        <div className="sp-220-single-E">
            <div className="title">{t('E_title')}</div>
            <Swiper
                className={`swiper-box`}
                modules={[Pagination]}
                spaceBetween={0}
                slidesPerView={'auto'}
                initialSlide={0}
                pagination={true}
                onSlideChange={(swiper) => setActive(swiper?.activeIndex || 0)}
                onSwiper={(swiperIns: any) => setSwiper(swiperIns)}
            >
                {arr?.map((item: any, k: number) => (
                    <SwiperSlide className="swiper-item" key={k}>
                        <div className="item-img">
                            <EFPicture
                                src={`/responsive/picture/solar-panel-220w-single/${item.img}.jpg`}
                                srcPad={`/responsive/picture/solar-panel-220w-single/${item.img}_768.jpg`}
                                srcMobile={`/responsive/picture/solar-panel-220w-single/${item.img}_768.jpg`}
                                alt={item.title}
                            />
                        </div>
                        <div className="item-info">
                            <div className="info-inner">
                                <p className="item-title">{item.title}</p>
                                <p className="item-desc">{item.desc}</p>
                            </div>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
            <div className="tabs">
                {arr?.map((item: any, k: number) => (
                    <span className={`tab${active === k ? ' active' : ''}`} key={k} onClick={() => handleSlideChange(k)}>
                        {item.title}
                    </span>
                ))}
            </div>
        </div>
    );
}
